import "regenerator-runtime/runtime";
import 'whatwg-fetch';
import 'core-js/features/promise';
import 'core-js/stable/array';
import 'core-js/stable/object';
import 'core-js/stable/string';
import 'core-js/stable/number';
